export const createFabric = <T extends unknown[], U>(Class: new(...values: T) => U) =>
    (...values: T) => new Class(...values)
